import React from 'react';
import Icon from './Icon';
import './ui.css';

const Input = ({
  label,
  subLabel,
  type = 'text',
  icon,
  error,
  className = '',
  wrapClassName = '',
  showPasswordToggle,
  onTogglePassword,
  passwordVisible,
  ...inputProps
}) => {
  const inputClasses = [
    'pn-input',
    icon ? 'pn-input--with-icon' : '',
    showPasswordToggle ? 'pn-input--with-toggle' : '',
    error ? 'pn-input--error' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={`pn-field ${wrapClassName}`.trim()}>
      {label ? <label className="pn-label">{label}</label> : null}
      {subLabel ? <p className="pn-sublabel">{subLabel}</p> : null}
      <div className="pn-input-wrap">
        {icon ? (
          <span className="pn-input-icon">
            <Icon name={icon} size={20} />
          </span>
        ) : null}
        <input type={type} className={inputClasses} {...inputProps} />
        {showPasswordToggle ? (
          <button
            type="button"
            className="pn-input-toggle"
            onClick={onTogglePassword}
            aria-label={passwordVisible ? 'Ocultar senha' : 'Mostrar senha'}
          >
            <Icon name={passwordVisible ? 'visibility-off' : 'visibility'} size={20} />
          </button>
        ) : null}
      </div>
      {error ? <p className="pn-field-error">{error}</p> : null}
    </div>
  );
};

export default Input;
